import firebase from '../../firebase/initFirebase';
import { GetState, SetState } from "zustand";
import { AppStatesI } from '../interfaces/storeStatesInterface';
import { convertResToMessage } from './shareActionFuncs';
import { userRef } from '../../firebase/refs';


export const loadUserAuth = async (setState: SetState<AppStatesI>, get: GetState<AppStatesI>) => {
    const localStorageUser = localStorage.getItem('goalOrganizer_user');
    const existingUser = localStorageUser ? JSON.parse(localStorageUser) : null;
    setState({ user: existingUser });
};


export const signInAuth = async (_provider: firebase.auth.AuthProvider, setState: SetState<AppStatesI>, get: GetState<AppStatesI>) => {
    firebase
        .auth()
        .signInWithPopup(_provider)
        .then((_res: any) => {
            const user = _res.user.providerData[0];
            localStorage.setItem('goalOrganizer_user', JSON.stringify(user));

            // if new user, add to DB
            userRef.orderByChild("email")
                .equalTo(user.email).once("value", snapshot => {
                    const userData = snapshot.val();
                    if (!userData) {
                        userRef.push(user);
                    }
                });

            setState({ user: user, isLoading: false });
        })
        .catch((_err: any) => {
            get().addMessage(convertResToMessage(_err));
            get().setLoading(false);
        });

};


export const logoutAuth = async (setState: SetState<AppStatesI>, get: GetState<AppStatesI>) => {
    firebase
        .auth()
        .signOut()
        .then((_res: any) => {
            setState({ user: null, isLoading: false });
            localStorage.removeItem('goalOrganizer_user');
        })
        .catch((_err: any) => {
            get().addMessage(convertResToMessage(_err));
            get().setLoading(false);
        });;
};